<template>
    <div>
        <div class="head">
            <img src="../assets/images/yy.png">
        </div>
        <ul class="items">
            <li class="yy1">
                <img src="../assets/images/yy1.png" alt="">
                <div class="text">
                    <h1>“1+X”套餐</h1>
                    <p>根据问卷结果，评估生成您的个性化体检套餐，更符合自身实际需求，检查更科学。</p>
                </div>
                <div class="star">
                    <img src="../assets/images/star.png" alt="">
                    <h1>推荐！</h1>
                </div>
            </li>
            <li class="yy2">
                <img src="../assets/images/yy2.png" alt="">
                <div class="text">
                    <h1>固定套餐</h1>
                    <p>根据问卷结果，评估生成您的个性化体检套餐，更符合自身实际需求，检查更科学。</p>
                </div>
            </li>
            <li class="yy3">
                <img src="../assets/images/yy3.png" alt="">
                <div class="text">
                    <h1>单项检查</h1>
                    <p>根据问卷结果，评估生成您的个性化体检套餐，更符合自身实际需求，检查更科学。</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
    }
</script>

<style scoped lang='less'>
    .head {
        position: relative;
        height: 10rem;
        img {
            width: 100%;
            height: 10rem;
        }
    }
    .items {
        margin: 0;
        padding: 0;
        .star{
            position: absolute;
            left: 0.5em;
            top: -1.2em;
            width: 5em;
            transform: rotate(345deg);
            img{
                width: 5em;
                height:  3em;
                position: absolute;
                top: 0;
            }
            h1{
                font-size: 16px;
                color: #fff;
                position: relative;
                line-height: 3em;
                text-align: center;
                
            }
        }
        li {
            height: 8em;
            margin-top: 2em;
            font-size: 1rem;
            background-size: 100% 8em !important;
            position: relative;
             
        }
        .text {
            width: 40% !important;
            font-size: 14px;
            text-align: left;
            margin-top: 1em;
        }
        img,
        .text {
            height: 8em;
            width: 60%;
            position: absolute;
            top: 0;
        }
        .yy1 {
            background: url(../assets/images/yy1.png) no-repeat;
            img,
            .text {
                right: 0;
            }
        }
        .yy2 {
            background: url(../assets/images/yy2.png) no-repeat;
            img,
            .text {
                left: 0;
            }
        }
        .yy3 {
            background: url(../assets/images/yy3.png) no-repeat;
            img,
            .text {
                right: 0;
            }
        }
        .text {
            h1 {
                font-family: '方正舒体 Bold', '方正舒体 Regular', '方正舒体';
                font-weight: 700;
                font-style: normal;
                font-size: 16px;
                color: #FF7C3E;
                text-align: center;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/YuYue.vue